import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
const cards = [{
  title: 'Simple & Clear',
  description: 'No tech jargon – just clear communication real solutions.',
  icon: 'https://cdn.magicpatterns.com/uploads/iWX7yZQL616MctESfPP4bX/dfsergfvd.svg',
  iconSize: 'w-12 h-12'
}, {
  title: 'Built for Africa',
  description: 'We build solutions tailored to the real modern African market.',
  icon: 'https://cdn.magicpatterns.com/uploads/up1R8cZgV7Jea8gVFV3BkD/Clip_path_group.svg',
  iconSize: 'w-10 h-10'
}, {
  title: 'Timely Delivery',
  description: 'We respect your deadlines and deliver when we promise.',
  icon: 'https://cdn.magicpatterns.com/uploads/ffoPsXmfV49KSp8T2Kri9E/Frame.svg',
  iconSize: 'w-10 h-10'
}, {
  title: 'Always Here',
  description: null,
  icon: 'https://cdn.magicpatterns.com/uploads/genp3UrNRnBMtQXLoRDF9u/Capa_1.svg',
  iconSize: 'w-10 h-10'
}];
export function WhyUsSection() {
  return <Section id="why-us" background="default" data-id="element-436">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-stretch" data-id="element-437">
        {/* Left Column: Content & Cards */}
        <div className="flex flex-col justify-center" data-id="element-438">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold font-heading text-[#0C0C0C] mb-4" data-id="element-439">
            Why choose Belo Digital
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600 mb-10 leading-relaxed max-w-xl" data-id="element-440">
            Choosing the right digital partner can make all the difference.
            Here's why businesses love working with us:
          </motion.p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-441">
            {cards.map((card, index) => <motion.div key={card.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + index * 0.1
          }} className="group bg-transparent rounded-2xl p-6 border-2 border-[#FF6600] flex flex-col cursor-default transition-colors duration-300 hover:bg-[#FF6600]" data-id="element-442">
                <div className="mb-6 shrink-0 h-12 flex items-center" data-id="element-443">
                  <img src={card.icon} alt="" className={`${card.iconSize} object-contain transition-all duration-300 group-hover:brightness-0 group-hover:invert`} data-id="element-444" />
                </div>
                <h3 className="text-xl font-bold font-heading text-[#FF6600] mb-3 transition-colors duration-300 group-hover:text-white" data-id="element-445">
                  {card.title}
                </h3>
                {card.title === 'Always Here' ? <p className="text-gray-600 leading-relaxed transition-colors duration-300 group-hover:text-white/90" data-id="element-446">
                    Support doesn't end after launch. We stick with you{' '}
                    <span className="text-[#FF6600] italic font-medium transition-colors duration-300 group-hover:text-white" data-id="element-447">
                      for life.
                    </span>
                  </p> : <p className="text-gray-600 leading-relaxed transition-colors duration-300 group-hover:text-white/90" data-id="element-448">
                    {card.description}
                  </p>}
              </motion.div>)}
          </div>
        </div>

        {/* Right Column: Illustration */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="hidden lg:block relative w-full h-full min-h-[500px]" data-id="element-449">
          <motion.div className="absolute inset-0 rounded-2xl border-2 border-[#FF6600] overflow-hidden" animate={{
          y: [0, -6, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          repeatType: 'reverse',
          ease: 'easeInOut'
        }} data-id="element-450">
            <img src="https://cdn.magicpatterns.com/uploads/4hW6WG1AQrRQWx4qCWSiK3/rgdfsdcfbgbvdsdrgt.svg" alt="Thinking character illustration" className="w-full h-full object-contain object-bottom" data-id="element-451" />
          </motion.div>
        </motion.div>
      </div>
    </Section>;
}